import React from 'react';
import ExpandableDiv from '../expandable_div/expandable_div';
import './warning_message.scss';


function WarningMessage(props) {
  const textStyle = {};

  if(props.color) {
    textStyle.color = props.color;
  }

  return (
    <ExpandableDiv
      className={`warning-message__wrapper${props.className ? ` ${props.className}` : ''}`}
      background={props.background || null}
      visible={props.visible}
      visibleMarginBottom={props.visibleMarginBottom}
    >

      <p
        className="warning-message__message"
        style={textStyle}
      >

        {props.message}

      </p>

      {!props.hideCloseButton &&
        <div className="warning-message__control-container">

          <button
            className="warning-message__close-button"
            style={textStyle}
            onClick={() => props.onClose()}
          >

            <i className="fas fa-times"></i>

          </button>

        </div>
      }

    </ExpandableDiv>
  );
}

export default WarningMessage;
